import useFeatureFlags from '@/hooks/useFeatureFlags';
import React, { memo, Suspense } from 'react';
import Button from '@/shared/Button';
import saleAssistVideoDemoIcon from '/public/images/saleAssistVideoDemoIcon.png';
import DownArrowIcon from '/public/images/DownArrowIcon.png';
import Image from '@/shared/Image';
import dynamic from 'next/dynamic';
import isAuthenticatedRoute from '@/utils/isAuthenticatedRoute';
import { ECOM_CART_URL, ECOM_CC_AGENT, LOGIN_URL } from '@/configs/constants';

const SaleAssist = dynamic(
  () =>
    import(/* webpackChunkName: "app-lazy-sale-assist-chunks" */ '@/components/SaleAssistWidget'),
  {
    ssr: false,
  },
);

type SaleAssistButtonProps = {
  saleAssist: boolean;
  toggleSaleAssist: Function;
  pathname: string;
  isFlutterClient?: boolean;
};

function SaleAssistButton({
  saleAssist,
  toggleSaleAssist,
  pathname,
  isFlutterClient,
}: SaleAssistButtonProps) {
  const { globalSaleAssist = false } = useFeatureFlags();
  const handleSaleAssistClick = () => {
    toggleSaleAssist(!saleAssist);
  };

  if (
    !globalSaleAssist ||
    isAuthenticatedRoute(pathname) ||
    pathname.startsWith(ECOM_CART_URL) ||
    pathname.startsWith(LOGIN_URL) ||
    pathname.startsWith(ECOM_CC_AGENT) ||
    pathname.startsWith('/ecom/payment') ||
    pathname.startsWith('/amc/select-duration') ||
    isFlutterClient
  )
    return null;

  return (
    <>
      <Button theme="link" className="!py-0" onClick={handleSaleAssistClick}>
        <Image
          className="w-full h-full"
          src={saleAssist ? DownArrowIcon.src : saleAssistVideoDemoIcon.src}
          alt="SaleAssistIcon"
        />
      </Button>
      {saleAssist && (
        <Suspense>
          <SaleAssist saleAssist={saleAssist} toggleSaleAssist={toggleSaleAssist} />
        </Suspense>
      )}
    </>
  );
}

export default memo(SaleAssistButton);
